const listingHighlightsTab = {
  displayField: 'header',
  name: 'Listing Highlights Tab',
  description: 'Tabs for Listing Highlights component',
  fields: [
    {
      id: 'type',
      name: 'Type',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [ { in: [ 'standard', 'community', 'school' ] } ],
      defaultValue: { 'en-US': 'standard' },
      disabled: false,
      omitted: false
    },
    {
      id: 'header',
      name: 'Header Name',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'items',
      name: 'Items',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'listingHighlightsTabListing' ] } ],
        linkType: 'Entry'
      }
    }
  ],
  sys: {
    id: 'listingHighlightsTab',
    version: 16,
    updatedAt: '2023-03-06T19:17:53.725Z'
  }
};
export default listingHighlightsTab;